import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import Select from 'react-select';

import { Button, Col, Input, Label, Row } from 'reactstrap';
import { Modal } from '../../../Components/Custom/modal';
import { SearchInputFilter } from '../../../Components/Custom/SearchInputFilter';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { addShadowBalance } from './slice';

interface ShadowBalanceProps {
  params: URLSearchParams;
  searchParams: any;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const AddShadowBalance = ({
  params,
  searchParams,
  isOpen,
  setIsOpen
}: ShadowBalanceProps) => {
  const dispatch = useAppDispatch();

  const { data } = useAppSelector((state) => state.shadowRanking);

  const userId = params.get('userId') || '';
  const [rankingSumOfPoAndUv, setRankingSumOfPoAndUv] = useState<string>('');
  const [ranking20Percent, setRanking20Percent] = useState<string>('');
  const [ranking404020, setRanking404020] = useState<string>('');
  const [rankingPoActive, setRankingPoActive] = useState<string>('');

  const [selectValue, setSelectValue] = useState<boolean | 'select'>('select');
  const [rankingLeftLegTotalVolume, setRankingLeftLegTotalVolume] =
    useState<string>('');
  const [rankingRightLegTotalVolume, setRankingRightLegTotalVolume] =
    useState<string>('');

  const toInputValue = (value: any) =>
    value !== undefined && value !== null ? String(value) : '';

  useEffect(() => {
    if (!isOpen || !userId) return;

    const user = data?.find((u: any) => String(u?.userId) === String(userId));

    setRankingSumOfPoAndUv(toInputValue(user?.rankingSumOfPoAndUv));
    setRanking20Percent(toInputValue(user?.ranking20Percent));
    setRanking404020(toInputValue(user?.ranking404020));
    setRankingPoActive(toInputValue(user?.rankingPoActive));

    setRankingLeftLegTotalVolume(toInputValue(user?.rankingLeftLegTotalVolume));
    setRankingRightLegTotalVolume(
      toInputValue(user?.rankingRightLegTotalVolume)
    );
    setSelectValue(
      typeof user?.hasPartnerWithPaidPackageInBothLegs === 'boolean'
        ? user.hasPartnerWithPaidPackageInBothLegs
        : 'select'
    );
  }, [isOpen, userId, data]);

  const selectOptions: { label: string; value: boolean }[] = [
    {
      label: 'True',
      value: true
    },

    {
      label: 'False',
      value: false
    }
  ];

  const handleSubmit = (e: any) => {
    e.preventDefault();

    const data = {
      userId: parseInt(userId),
      rankingSumOfPoAndUv: parseFloat(rankingSumOfPoAndUv),
      ranking20Percent: parseFloat(ranking20Percent),
      ranking404020: parseFloat(ranking404020),
      rankingPoActive: parseFloat(rankingPoActive),
      rankingLeftLegTotalVolume: parseFloat(rankingLeftLegTotalVolume),
      rankingRightLegTotalVolume: parseFloat(rankingRightLegTotalVolume),
      rankingPV: 0,
      hasPartnerWithPaidPackageInBothLegs: selectValue === true
    };

    dispatch(addShadowBalance(data));
    handleClearState();
  };

  const handleClearState = () => {
    setIsOpen(!isOpen);

    setRankingSumOfPoAndUv('');
    searchParams((prevParams: URLSearchParams) => {
      prevParams.delete('userId');
      return prevParams;
    });
    setRanking20Percent('');
    setRanking404020('');
    setRankingPoActive('');

    setRankingLeftLegTotalVolume('');
    setRankingRightLegTotalVolume('');
    setSelectValue('select');
  };

  return (
    <>
      <Button color='primary' onClick={() => setIsOpen(!isOpen)}>
        Update Shadow Ranking
      </Button>
      <Modal
        isOpen={isOpen}
        setIsOpen={() => setIsOpen(!isOpen)}
        title='Update Shadow Ranking '
        size='xl'
        form
        onFormSubmit={handleSubmit}
        actions={
          <>
            <Button color='primary' onClick={handleClearState}>
              Cancel
            </Button>
            <Button
              color='primary'
              type='submit'
              disabled={
                !userId ||
                !rankingSumOfPoAndUv ||
                !ranking20Percent ||
                !ranking404020 ||
                !rankingPoActive ||
                !rankingLeftLegTotalVolume ||
                !rankingRightLegTotalVolume
              }>
              Add
            </Button>
          </>
        }>
        <Row>
          <Col lg={3}>
            <Label className='w-100 text-left' for='userId'>
              User ID
            </Label>
            <SearchInputFilter
              param='userId'
              searchParams={params}
              setSearchParams={searchParams}
              placeholder='Search User ID'
            />
          </Col>
          <Col lg={3}>
            <Label for='transaction'>Ranking Sum of PO and UV </Label>
            <Input
              id='transaction'
              className='w-100 mb-2'
              type='text'
              value={rankingSumOfPoAndUv}
              onChange={(e) => setRankingSumOfPoAndUv(e.target.value)}
              placeholder='Enter here'
            />
          </Col>

          <Col lg={3}>
            <Label className='w-100 text-left' for='amount'>
              Ranking 20%
            </Label>
            <Input
              id='amount'
              className='w-100 mb-2'
              type='number'
              name='number'
              step='any'
              value={ranking20Percent}
              onChange={(e) => setRanking20Percent(e.target.value)}
              placeholder='Enter here'
            />
          </Col>
          <Col lg={3}>
            <Label className='w-100 text-left' for='shopping'>
              Ranking 40%40%20%
            </Label>
            <Input
              id='shopping'
              className='w-100 mb-2'
              type='number'
              name='number'
              step='any'
              value={ranking404020}
              onChange={(e) => setRanking404020(e.target.value)}
              placeholder='Enter here'
            />
          </Col>
        </Row>
        <Row>
          <Col lg={3}>
            <Label className='w-100 text-left' for='loyality'>
              Ranking PO Active
            </Label>
            <Input
              id='shopping'
              className='w-100 mb-2'
              type='number'
              name='number'
              step='any'
              value={rankingPoActive}
              onChange={(e) => setRankingPoActive(e.target.value)}
              placeholder='Enter here'
            />
          </Col>

          <Col lg={3}>
            <Label className='w-100 text-left' for='loyality'>
              Left Leg Total Volume
            </Label>
            <Input
              id='myLifePoints'
              className='w-100 mb-2'
              type='number'
              name='number'
              step='any'
              value={rankingLeftLegTotalVolume}
              onChange={(e) => setRankingLeftLegTotalVolume(e.target.value)}
              placeholder='Enter here'
            />
          </Col>

          <Col lg={3}>
            <Label for='title'> Right Leg Total Volume</Label>
            <Input
              id='title'
              className='w-100 mb-2'
              type='number'
              value={rankingRightLegTotalVolume}
              onChange={(e) => setRankingRightLegTotalVolume(e.target.value)}
              placeholder='Enter here'
            />
          </Col>
          <Col lg={3}>
            <Label for='title'> Qualified Partner Rank</Label>
            <Select
              value={
                selectOptions.find((option) => option.value === selectValue) ??
                null
              }
              onChange={(option) => {
                setSelectValue(option?.value ?? 'select');
              }}
              options={selectOptions}
              placeholder={'Select'}
              isSearchable={false}
            />
          </Col>
        </Row>

        <Row>
          <Col lg={12} style={{ marginTop: 20 }}>
            *In our system "Ranking Sum of PO and UV" is a required condition
            for achieving a rank.
          </Col>
          <Col lg={12} style={{ marginLeft: 6 }}>
            The admin user must enter a value in this field that is greater than
            or equal to the "required BV for the Weak Team" for the target rank.
          </Col>
        </Row>
      </Modal>
    </>
  );
};
